/**
 * Persisted UI locale for the student area only (backoffice/company unchanged).
 */
export const STUDENT_UI_LOCALE_KEY = 'student-ui-locale';

export type StudentLocale = 'es' | 'en';

export function getStoredStudentLocale(): StudentLocale {
  try {
    const v = localStorage.getItem(STUDENT_UI_LOCALE_KEY);
    if (v === 'en' || v === 'es') return v;
  } catch {
    /* ignore */
  }
  return 'es';
}

export function setStoredStudentLocale(locale: StudentLocale): void {
  try {
    localStorage.setItem(STUDENT_UI_LOCALE_KEY, locale);
  } catch {
    /* ignore */
  }
}
